<template>
  <v-btn
    icon
    @click="clickedBack"
  >
    <v-icon>mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'backbutton',
  props: {
    backTarget: {
      default: '/',
      type: String,
    },
  },
  components: {
  },
  data() {
    return {
      currentUrl: window.location,
      appState: this.$root.$data.appStore.state,
    }
  },
  computed: {
    userSignedIn: function () {
      return this.appState.user.uid !== undefined;
    },
  },
  methods: {
    clickedBack() {
      if(!this.userSignedIn) {
        this.$router.push('/');
        return;
      }
      this.$router.push(this.backTarget);
    }
  }
}
</script>
